// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"c4b9e1af","388":"f104b37b","754":"4925ba79","840":"9d245c52","842":"a1fe9c37"}[chunkId] + ".chunk.js";
};